import { AuthAssets } from '@porterin/booking-flow/src/auth/view/stores/AuthStore';
import { OrderReviewAssets } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import Image from 'next/image';

const AuthCloseCmp = ({ close_modal }: { close_modal: () => void }) => {
  return (
    <>
      <Image
        src={OrderReviewAssets.arrowLeftIcon.src}
        alt={OrderReviewAssets.arrowLeftIcon.alt}
        width={20}
        height={20}
        className="lg:hidden absolute top-6 left-6"
        onClick={close_modal}
      />
      <Image
        src={AuthAssets.crossBlackIcon.src}
        className="absolute top-8 right-8 cursor-pointer max-lg:hidden"
        width={24}
        height={24}
        alt={AuthAssets.crossBlackIcon.alt}
        onClick={close_modal}
      />
    </>
  );
};

export default AuthCloseCmp;
